<template>
    <v-container>
        <v-card>
            <v-card-title>
                <span class="headline">{{ $t('inactiveRequestSettings')|capitalize }}</span>
            </v-card-title>
            <v-card-text>
                <v-layout align-center justify-center row>
                    <v-flex>
                        <v-layout column>
                            <v-flex class="mb-2">
                                <div class="pb-5" >
                                <v-switch v-model="botConfig['enableAutoMad']" v-on:change="changeEnableAutoMad" :false-value="'0'" :true-value="'1'" :hide-details="true">
                                    <template v-slot:label>
                                        <div>
                                            {{ $t('autoHandleInactiveRequest')|capitalize }}:
                                            <strong v-show="botConfig['enableAutoMad']==='1'" class="success--text">{{ $t('on')|capitalize }}</strong>
                                            <strong v-show="botConfig['enableAutoMad']!=='1'"  class="error--text">{{ $t('off')|capitalize }}</strong>
                                        </div>
                                    </template>
                                </v-switch>
                                <div class="pl-3">
                                    <v-switch v-for="(channel, index) in  channel_list" :key="index"
                                        :label="$t(channel)" style="text-transform: capitalize"
                                        v-model="selected_channels" :value="channel"
                                        :hide-details="true" v-on:change="changeSelectedChannel"></v-switch>
                                </div>
                                </div>

                                <!-- New UI -->

                                <v-layout row wrap class="mt-1 mb-2" v-for="auto_mad_case of case_list" :key="auto_mad_case.name">
                                    <v-flex xs12 class="px-2" style="border: 1px solid #c5c5c5; border-radius: 5px;">
                                        <v-layout row wrap>
                                            <v-flex xs12 class="pt-1 pb-3">
                                                <div><b>{{ auto_mad_case.label }}</b></div>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap>
                                            <v-flex xs12 class="pr-1">
                                                <v-text-field class="form-control pt-0 mt-0 px-2"
                                                    v-model="botConfig['autoMadConfigs'][auto_mad_case.name].wait_time_minutes"
                                                    mask="###############"
                                                    v-on:change="updateAutoMadConfigs"
                                                    :rules="[formRules.ruleMin(1)]"
                                                    :suffix="$t('minute')"
                                                    :label="$t('autoMadWaitingTimeMinutes')">
                                                </v-text-field>
                                            </v-flex>
                                            <v-flex xs12 class="mt-2">
                                                <v-select
                                                    :items="auto_mad_case.actions"
                                                    :label="$t('action')|capitalize"
                                                    v-model="botConfig['autoMadConfigs'][auto_mad_case.name].action"
                                                    v-on:change="updateAutoMadConfigs"
                                                    style="margin-top: -12px;"
                                                ></v-select>
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-textarea
                                                    rows="2"
                                                    :label="$t('notifyMessage')"
                                                    v-model="botConfig['autoMadConfigs'][auto_mad_case.name].message"
                                                    v-on:change="updateAutoMadConfigs"
                                                    v-show="botConfig['autoMadConfigs'][auto_mad_case.name].action !== action_list.do_nothing.value"
                                                ></v-textarea>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap v-show="['case_last_message_from_agent', 'case_last_message_from_user'].includes(auto_mad_case.name) && botConfig['enableAutoMadV2'] === '1' && botConfig['autoMadConfigs'][auto_mad_case.name].action === action_list.auto_mad.value && botConfig['autoMadConfigs'][auto_mad_case.name].wait_time_minutes >= 5">
                                            <v-flex shrink>
                                              <v-switch class="form-control pt-2 mt-0 px-2"
                                                v-model="checkbox_notify[auto_mad_case.name]"
                                                v-on:change="changeEnableNotify(auto_mad_case.name)"
                                              ></v-switch>
                                            </v-flex>
                                            <v-flex xs11>
                                              <v-text-field class="form-control pt-0 mt-0 px-2"
                                                            v-model="botConfig['autoMadConfigs'][auto_mad_case.name].notify_time_minutes"
                                                            mask="###############"
                                                            v-on:change="updateAutoMadConfigs"
                                                            :suffix="$t('minute')"
                                                            :label="$t('autoMadNotifyTimeMinutes')"
                                              ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <!-- END -->
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <div class="chat_view_loading" v-if="loadingDialog">
                <div class="loading_overlay"></div>
                <v-progress-circular indeterminate size="54" color="white"></v-progress-circular>
            </div>
        </v-card>
    </v-container>
</template>

<script>
    import BotService from "@/services/bot.service";
    import {mapMutations, mapState} from "vuex";
    import FormMixin from '@/mixins/FormMixin'

    export default {
        name: "AutoMadSetting",
        mixins: [FormMixin],
        props: {
            botCode: String,
        },
        computed: {
            ...mapState('config', ['botConfig']),
          checkbox_notify: function() {
              return {
                case_unassigned: false,
                case_last_message_from_agent: this.botConfig['autoMadConfigs'].case_last_message_from_agent.notify_time_minutes >= 1,
                case_last_message_from_user: this.botConfig['autoMadConfigs'].case_last_message_from_user.notify_time_minutes >= 1,
              };
          }
        },
        data() {
            const ACTION_LIST = {
                do_nothing: {text: this.$t('autoMadActionDoNothing'), value: 'do_nothing'},
                auto_mad: {text: this.$t('autoMadActionAutoMad'), value: 'auto_mad'},
                turn_on_bot: {text: this.$t('autoMadActionTurnOnBot'), value: 'turn_on_bot'},
                send_message: {text: this.$t('autoMadActionSendMessage'), value: 'send_message'},
            };
            return {
                loadingDialog: false,
                action_list: ACTION_LIST,
                case_list: [
                    {name: "case_unassigned", label: this.$t("autoMadCaseUnassigned"),
                        actions: [ACTION_LIST.do_nothing, ACTION_LIST.auto_mad, ACTION_LIST.turn_on_bot, ACTION_LIST.send_message]},
                    {name: "case_last_message_from_agent", label: this.$t("autoMadCaseLastMessageAgent"),
                        actions: [ACTION_LIST.do_nothing, ACTION_LIST.auto_mad, ACTION_LIST.send_message]},
                    {name: "case_last_message_from_user", label: this.$t("autoMadCaseLastMessageUser"),
                        actions: [ACTION_LIST.do_nothing, ACTION_LIST.auto_mad, ACTION_LIST.send_message]},
                ],
                channel_list: [],
                selected_channels: []
            }
        },
        mounted() {
            if (this.botCode) {
                BotService.getListChannels(this.botCode).then((list_channels) => {
                    this.channel_list = list_channels.data.channels;
                    if (this.botConfig['enableAutoMad'] !== "1") {
                        this.selected_channels = [];
                        return;
                    }
                    this.selected_channels = [...this.channel_list]
                    if (this.botConfig['autoMadConfigs'].disable_channels && this.botConfig['autoMadConfigs'].disable_channels.length > 0) {
                        for (let channel of this.botConfig['autoMadConfigs'].disable_channels) {
                            if (channel === 'old_livechat') {
                                channel = 'livechat'
                            }
                            let index = this.selected_channels.indexOf(channel);
                            if (index !== -1) {
                                this.selected_channels.splice(index, 1);
                            }
                        }
                    }
                });
            }
        },
        methods: {
            ...mapMutations('config', ['setBotConfig']),
            updateEnableAutoMad() {
                this.loadingDialog = true;
                BotService.updateEnableAutoMad(this.botCode, this.botConfig['enableAutoMad'])
                    .then(()=> {
                        this.setBotConfig({enable_auto_mad: this.botConfig['enableAutoMad']});
                        this.$AppService.toastSuccess("Update config success.");
                }).catch(()=>{
                    this.$AppService.toastError("Update config failed");
                }).finally(() => {
                    this.loadingDialog = false;
                })
            },
            changeEnableAutoMad() {
                if (this.botConfig['enableAutoMad'] === "1") {
                    this.selected_channels = [...this.channel_list];
                } else {
                    this.selected_channels = [];
                }
                this.updateEnableAutoMad()
                this.updateAutoMadConfigs();
            },
            changeSelectedChannel() {
                if (this.selected_channels.length === 0 && this.botConfig['enableAutoMad'] === "1") {
                    this.botConfig['enableAutoMad'] = "0";
                    this.updateEnableAutoMad()
                } else if (this.selected_channels.length !== 0 && this.botConfig['enableAutoMad'] === "0") {
                    this.botConfig['enableAutoMad'] = "1";
                    this.updateEnableAutoMad()
                }
                this.updateAutoMadConfigs();
            },
            updateAutoMadConfigs() {
                this.loadingDialog = true;
                let wait_time = parseInt(this.botConfig['autoMadConfigs'].wait_time_minutes);
                if (isNaN(wait_time) || wait_time <= 0) {
                    wait_time = 1
                }
                this.botConfig['autoMadConfigs'].wait_time_minutes = wait_time;
                for (const auto_mad_case of this.case_list) {
                  wait_time = parseInt(this.botConfig['autoMadConfigs'][auto_mad_case.name]?.wait_time_minutes)
                  if (isNaN(wait_time) || wait_time <= 0) {
                    wait_time = 1
                  }
                  this.botConfig['autoMadConfigs'][auto_mad_case.name].wait_time_minutes = wait_time;
                  this.calculateNotifyTime(auto_mad_case.name)
                }
                let disable_channels = []
                for (let channel of this.channel_list) {
                    if (!this.selected_channels.includes(channel)) {
                        disable_channels.push(channel)
                        if (channel === 'livechat') disable_channels.push('old_livechat')
                    }
                }
                this.botConfig['autoMadConfigs'].disable_channels = disable_channels;
                BotService.updateAutoMadConfigs(this.botCode, this.botConfig['autoMadConfigs'])
                    .then(()=> {
                        this.setBotConfig({auto_mad_configs: this.botConfig['autoMadConfigs']});
                        this.$AppService.toastSuccess("Update config success.");
                    }).catch(()=>{
                    this.$AppService.toastError("Update config failed");
                }).finally(() => {
                    this.loadingDialog = false;
                });
            },
            calculateNotifyTime(case_name) {
              let notify_time_minutes, wait_time_minutes
              try {
                notify_time_minutes = parseInt(this.botConfig["autoMadConfigs"][case_name].notify_time_minutes);
                wait_time_minutes = parseInt(this.botConfig["autoMadConfigs"][case_name].wait_time_minutes);
                if (notify_time_minutes >= 1 && notify_time_minutes <= (wait_time_minutes - 3)) {
                  this.botConfig["autoMadConfigs"][case_name].notify_time_minutes = notify_time_minutes;
                } else if (notify_time_minutes > (wait_time_minutes - 3)) {
                  this.botConfig["autoMadConfigs"][case_name].notify_time_minutes = wait_time_minutes - 3;
                } else {
                  this.botConfig["autoMadConfigs"][case_name].notify_time_minutes = null;
                }
              } catch (e) {
                console.error(e);
                this.botConfig["autoMadConfigs"][case_name].notify_time_minutes = null
              }
            },
          changeEnableNotify(case_name) {
            if (this.checkbox_notify[case_name]) {
              let wait_time_minutes = parseInt(this.botConfig["autoMadConfigs"][case_name].wait_time_minutes);
              if (wait_time_minutes < 5) {
                wait_time_minutes = this.botConfig["autoMadConfigs"][case_name].wait_time_minutes = 5;
              }
              this.botConfig["autoMadConfigs"][case_name].notify_time_minutes = wait_time_minutes - 3;
            } else {
              this.botConfig["autoMadConfigs"][case_name].notify_time_minutes = null;
            }
            this.updateAutoMadConfigs();
          },
        },
    }
</script>

<style scoped>
</style>

<style scoped lang="scss" src="../../components/style/chat-view.scss"></style>
